import * as React from 'react';

import { Tooltip } from '@opendoor/bricks/complex';
import { Flex, Image, Text } from '@opendoor/bricks/core';

interface IProps {
  id?: string;
  imageUrl?: string;
  subtitle?: string;
  title?: string;
  tooltip?: string;
  unboundedWidth?: boolean;
}

const QuestionLabel: React.FC<IProps> = ({
  id,
  imageUrl,
  subtitle,
  title,
  tooltip,
  unboundedWidth,
}) => {
  if (!title) {
    return null;
  }
  return (
    <Flex
      width={unboundedWidth ? '100%' : [imageUrl ? '220px' : '180px', '225px']}
      alignItems="center"
      pr={3}
    >
      {imageUrl && (
        <Flex pr={[3, 4]} width={['36px', '42px']}>
          <Image width="100%" maxHeight="30px" src={imageUrl} alt={`${title} icon`} />
        </Flex>
      )}
      <Flex flexDirection="column">
        <Text as="label" id={id} fontWeight="semibold" fontSize="s1" color="neutrals100">
          {title} {subtitle && `(${subtitle})`}
        </Text>
      </Flex>
      {tooltip && (
        <Flex pl={2}>
          <Tooltip
            label={'Additional information for answering this question'}
            analyticsName={`reception-fe-${title
              .toLowerCase()
              .split(' ')
              .join('-')}-question-label-tooltip`}
            popupDirection="top"
          >
            {tooltip}
          </Tooltip>
        </Flex>
      )}
    </Flex>
  );
};

export default QuestionLabel;
